query NotifyTypes($orderBy: [NotifyTypesOrderBy!]) {
  notifyTypes(orderBy: $orderBy) {
    nodes {
      id
      description
    }
  }
}
